import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppVersionService } from '@app/services/app-version.service';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private http: HttpClient;

  constructor(handler: HttpBackend, private appVersionService: AppVersionService) {
    this.http = new HttpClient(handler);
  }

  public getData<T>(route: string, type: 'json' | 'html' | null = null): Observable<T> {
    const options = { ...this.generateHeaders() };
    if (type === 'html') options['responseType'] = 'text';

    return this.http.get<T>(this.composeRoute(route, environment.apiUrl), options);
  }

  public post<T>(route: string, body?: unknown): Observable<T> {
    return this.http.post<T>(this.composeRoute(route, environment.apiUrl), body, this.generateHeaders());
  }

  public create<T>(route: string, body: unknown): Observable<T> {
    return this.http.post<T>(this.composeRoute(route, environment.apiUrl), body, this.generateHeaders());
  }

  public associate<T>(route: string, body: unknown): Observable<T> {
    return this.http.post<T>(this.composeRoute(route, environment.apiUrl), body, this.generateHeaders());
  }

  public update<T>(route: string, body: unknown): Observable<T> {
    return this.http.put<T>(this.composeRoute(route, environment.apiUrl), body, this.generateHeaders());
  }

  public delete<T>(route: string): Observable<T> {
    return this.http.delete<T>(this.composeRoute(route, environment.apiUrl), this.generateHeaders());
  }

  private composeRoute(route: string, environmentUrl: string): string {
    return `${environmentUrl}/${route}`;
  }

  private generateHeaders() {
    return {
      headers: new HttpHeaders({ 'X-PU-VERSION': this.appVersionService.getCurrentVersion() }),
    };
  }
}
